var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmedStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.79753e-06L2 3.49691e-07C0.89 1.55613e-07 -1.57361e-07 0.9 -3.49691e-07 2L-2.79753e-06 16C-2.98986e-06 17.1 0.889997 18 2 18L16 18C17.11 18 18 17.1 18 16L18 2C18 0.900003 17.11 2.99161e-06 16 2.79753e-06ZM7 14L2 9L3.41 7.59L7 11.17L14.59 3.58L16 5L7 14Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8.46,
    y1: -13.0714,
    x2: 28.6271,
    y2: 9.11771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92D142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503996,
    stopColor: "#34AF20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983171,
    stopColor: "#09955A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmedStatus);
export default __webpack_public_path__ + "static/media/confirmed-status.02c195be.svg";
export { ForwardRef as ReactComponent };